/**
 * global.js — MORAY IUROP THEME
 * Base global behavior only. Product variant/GLO integration lives in
 * assets/moray-glo-bridge.js and PDP/cart state lives in iurop-product.js /
 * iurop-cart-drawer.js. Do not duplicate those owners here.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var locOpt = event.target.closest('[data-loc-opt]');
    if (locOpt) {
      var loc = locOpt.closest('[data-loc]');
      var select = loc && loc.querySelector('select');
      if (select) {
        select.value = locOpt.getAttribute('data-loc-value');
        if (select.form) select.form.submit();
      }
      return;
    }

    var locToggle = event.target.closest('[data-loc-toggle]');
    document.querySelectorAll('[data-loc]').forEach(function (loc) {
      var panel = loc.querySelector('[data-loc-panel]');
      var btn = loc.querySelector('[data-loc-toggle]');
      if (!panel || !btn) return;

      if (locToggle && loc.contains(locToggle)) {
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        loc.classList.toggle('is-open', open);
        if (open) {
          var active = panel.querySelector('.is-active');
          if (active) active.scrollIntoView({ block: 'center' });
        }
      } else {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        loc.classList.remove('is-open');
      }
    });
  });
})();

/** CRIS DUPLICATE — coherencia de interfaz EN. */
(function () {
  'use strict';

  function isEnglish() {
    return String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  }

  var copy = {
    'ropa':'Clothing','accesorios':'Accessories','categorías':'Categories','categorias':'Categories',
    'bestseller':'Bestsellers','bestsellers':'Bestsellers','novedades':'New in','conoce moray':'About Moray',
    'ver prendas':'View garments','ver todos':'View all','ver todo':'View all','ver todas':'View all',
    'camisetas':'T-shirts','sudaderas':'Sweatshirts','pantalones':'Trousers','polos':'Polo shirts',
    'bañadores':'Swimwear','banadores':'Swimwear','jerséis':'Jumpers','jerseis':'Jumpers','jerseys':'Jumpers',
    'abrigos':'Coats','zapatos':'Shoes','camisas':'Shirts','calcetines':'Socks','packs de calcetines':'Sock packs'
  };

  function translateExact(el) {
    if (!el) return;
    var raw = String(el.textContent || '').trim();
    var translated = copy[raw.toLowerCase()];
    if (translated) el.textContent = translated;
  }

  function translateInterface(root) {
    if (!isEnglish()) return;
    root = root && root.querySelectorAll ? root : document;

    root.querySelectorAll(
      '.iurop-header__nav-link,.iurop-header__mobmenu-root,.iurop-header__mobmenu-sub a,' +
      '.iurop-header__mega a,.iurop-header__mega summary,.iurop-header__strip-link,.moray-view-all,' +
      '.iurop-category-grid__label,.moray-story__link,.moray-story__cta'
    ).forEach(translateExact);

    root.querySelectorAll('.iurop-plp__chips-more').forEach(function (button) {
      var text = String(button.textContent || '').trim();
      var allMatch = text.match(/^Ver todas\s*\((\d+)\)$/i);
      if (allMatch) button.textContent = 'View all (' + allMatch[1] + ')';
      else if (/^Ver menos$/i.test(text)) button.textContent = 'View less';
    });

    root.querySelectorAll('.iurop-pdp__size-error').forEach(function (el) {
      if (String(el.textContent || '').trim().toLowerCase() === 'confirma tu talla primero') {
        el.textContent = 'Select your size first';
      }
    });

    root.querySelectorAll('[data-pdp-ugc-open]').forEach(function (button, index) {
      var label = button.getAttribute('aria-label') || '';
      if (/^Abrir imagen/i.test(label)) button.setAttribute('aria-label', 'Open look image ' + (index + 1));
    });

    var faq = {
      '¿Qué talla elijo?': {
        q:'What size should I choose?',
        a:'<p>Each product page includes a size guide with the garment measurements laid flat, including chest, total length and sleeve length from the shoulder. If you are between two sizes, choose the larger one for a more oversized fit. If you are still unsure, contact us and we will help you choose.</p>'
      },
      '¿Cómo cuido mis prendas de algodón?': {
        q:'How should I care for my cotton garments?',
        a:'<p>Wash your garments inside out in cold water, at a maximum of 30°C, with similar colours. Avoid the tumble dryer and iron inside out without ironing directly over prints or screen prints. This helps the cotton keep its shape and colour for longer.</p>'
      },
      '¿Puedo pagar en varios plazos?': {
        q:'Can I pay in instalments?',
        a:'<p>Yes. With Klarna you can split your purchase into 3 interest-free payments. You pay one third when the order is confirmed and the remaining two payments are charged automatically every 30 days. Simply choose Klarna at checkout; subject to Klarna approval.</p>'
      },
      '¿Cómo puedo contactar con vosotros?': {
        q:'How can I contact you?',
        a:'<p>You can email us at contact@moray.es or visit our Madrid store at Calle Fernández de la Hoz 56. If your order has not arrived within the estimated time, send us your order number and we will check it. If an item arrives faulty, has a manufacturing defect or is incorrect, send us a photo of the issue and we will arrange a free exchange or a full refund. We will get back to you as soon as possible.</p>'
      }
    };

    root.querySelectorAll('.iurop-faq__item').forEach(function (item) {
      var question = item.querySelector('.iurop-faq__question-text');
      var answer = item.querySelector('.iurop-faq__answer');
      if (!question || !answer) return;
      var entry = faq[String(question.textContent || '').trim()];
      if (!entry) return;
      question.textContent = entry.q;
      answer.innerHTML = entry.a;
    });
  }

  function run() { translateInterface(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('iurop:plp:render', run);
})();

/* Product/GLO campaign hotfixes intentionally removed from global.js.
   Product option ownership is centralized in moray-glo-bridge.js + iurop-product.js. */
